import { LocationData } from "@/components/locations/LocationPage";

export const locations: LocationData[] = [
  {
    slug: "johannesburg",
    city: "Johannesburg",
    province: "Gauteng",
    metaTitle: "Bookkeeping Services Johannesburg | SAICA Registered | From R350/m",
    metaDescription: "Professional bookkeeping services in Johannesburg. Monthly bookkeeping, payroll, SARS compliance, tax returns & CIPC annual returns. SAICA registered. Packages from R350/month.",
    heroTitle: "Bookkeeping Services in Johannesburg",
    heroDescription: "SAICA registered bookkeeping, payroll, and SARS compliance services for Johannesburg businesses. From startups in Sandton to SMEs in Soweto — we handle your books so you can focus on growth.",
    intro: "Johannesburg is the economic powerhouse of South Africa, home to the JSE and thousands of thriving businesses. Whether you're running a consultancy in Sandton, a retail business in Rosebank, or a manufacturing operation in the south, staying on top of your bookkeeping and SARS obligations is critical to your success.",
    localInsight: "As Gauteng's business hub, Johannesburg businesses face unique compliance pressures — from B-BBEE reporting requirements to managing multi-branch operations. Our team understands the fast-paced JHB business environment and delivers accurate, timely bookkeeping that keeps you ahead of deadlines.",
    whyLocal: [
      "Deep understanding of Gauteng's business landscape",
      "Experience with diverse industries across Johannesburg",
      "Remote service — no traffic, no wasted time",
      "SAICA registered professionals",
      "Packages from just R350/month",
      "Full SARS compliance included",
    ],
  },
  {
    slug: "cape-town",
    city: "Cape Town",
    province: "Western Cape",
    metaTitle: "Bookkeeping Services Cape Town | SAICA Registered | From R350/m",
    metaDescription: "Professional bookkeeping services in Cape Town. Monthly bookkeeping, payroll, SARS compliance, tax returns & CIPC annual returns. SAICA registered. Packages from R350/month.",
    heroTitle: "Bookkeeping Services in Cape Town",
    heroDescription: "SAICA registered bookkeeping, payroll, and SARS compliance services for Cape Town businesses. From tech startups in Woodstock to hospitality in the V&A — we keep your finances in order.",
    intro: "Cape Town's diverse economy spans tech, tourism, agriculture, and creative industries. Whether you're a startup in the Woodstock tech corridor, a wine estate in Stellenbosch, or a hospitality business along the Atlantic Seaboard, professional bookkeeping ensures you stay compliant and profitable.",
    localInsight: "The Western Cape's seasonal tourism industry and growing tech sector create unique bookkeeping challenges — from managing seasonal cash flow to handling foreign client invoicing. We provide consistent, reliable financial administration tailored to Cape Town's dynamic business environment.",
    whyLocal: [
      "Understanding of Western Cape's seasonal industries",
      "Experience with tech, tourism & creative businesses",
      "Remote service — available across the Cape",
      "SAICA registered professionals",
      "Packages from just R350/month",
      "Full SARS compliance included",
    ],
  },
  {
    slug: "durban",
    city: "Durban",
    province: "KwaZulu-Natal",
    metaTitle: "Bookkeeping Services Durban | SAICA Registered | From R350/m",
    metaDescription: "Professional bookkeeping services in Durban. Monthly bookkeeping, payroll, SARS compliance, tax returns & CIPC annual returns. SAICA registered. Packages from R350/month.",
    heroTitle: "Bookkeeping Services in Durban",
    heroDescription: "SAICA registered bookkeeping, payroll, and SARS compliance services for Durban businesses. From logistics at the port to retail in Umhlanga — we manage your financial admin with precision.",
    intro: "Durban is South Africa's busiest port city and a major hub for manufacturing, logistics, and trade. Businesses in eThekwini face complex supply chain finances, import/export documentation, and stringent compliance requirements that demand professional bookkeeping support.",
    localInsight: "KwaZulu-Natal's strong manufacturing and shipping sectors require meticulous financial record-keeping, especially for businesses dealing with customs and international trade. Our team delivers the accuracy and consistency that Durban's industrious business community demands.",
    whyLocal: [
      "Experience with trade, logistics & manufacturing businesses",
      "Understanding of KZN's business regulations",
      "Remote service — Durban, Umhlanga, Pietermaritzburg & beyond",
      "SAICA registered professionals",
      "Packages from just R350/month",
      "Full SARS compliance included",
    ],
  },
  {
    slug: "pretoria",
    city: "Pretoria",
    province: "Gauteng",
    metaTitle: "Bookkeeping Services Pretoria | SAICA Registered | From R350/m",
    metaDescription: "Professional bookkeeping services in Pretoria. Monthly bookkeeping, payroll, SARS compliance, tax returns & CIPC annual returns. SAICA registered. Packages from R350/month.",
    heroTitle: "Bookkeeping Services in Pretoria",
    heroDescription: "SAICA registered bookkeeping, payroll, and SARS compliance services for Pretoria businesses. From government contractors in Centurion to professionals in Hatfield — your books are in safe hands.",
    intro: "As South Africa's administrative capital, Pretoria is home to a thriving economy driven by government services, education, automotive manufacturing, and professional services. Businesses here need reliable bookkeeping that meets the exacting standards expected in the capital.",
    localInsight: "Many Pretoria businesses work with government contracts that require impeccable financial records and compliance documentation. Our team ensures your books are always audit-ready, your SARS submissions are on time, and your financial reporting meets the highest standards.",
    whyLocal: [
      "Experience with government contractors & tenders",
      "Understanding of public sector compliance needs",
      "Remote service — Pretoria, Centurion, Midrand & surrounds",
      "SAICA registered professionals",
      "Packages from just R350/month",
      "Full SARS compliance included",
    ],
  },
];

export function getLocationBySlug(slug: string): LocationData | undefined {
  return locations.find((l) => l.slug === slug);
}
